import React, { useEffect, useState } from 'react';
import TabPage from 'components/common/TabPage';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { Spinner, Modal, Button } from 'react-bootstrap';
import { formChangedAction } from 'actions';
import { addLitigationTypeMasterAPI, getLitigationTypeMasterListAPI, litigationTypeAction, litigationTypeErrorAction, updateLitigationTypeMasterAPI } from 'actions/LitigationTypesMaster/litigationTypesMasterAction';
import TabPage1 from 'components/common/TabPage1';
import { addLitigationTypeMasterDetailAPI, getLitigationTypeDetailListAPI, litigationTypeDetailAction, litigationTypeDetailErrorAction, updateLitigationTypeMasterDetailAPI } from 'actions/LitigationTypesDetail/litigationTypesDetailAction';
import loader from '../../assets/img/loader.svg'

const tabArray = ['Litigation List', 'Add Litigation Type Detail'];

const listColumnArray = [
  { accessor: 'sl', Header: 'S. No' },
  { accessor: 'litigationCode', Header: 'Litigation Code' },
  { accessor: 'litigationName', Header: 'Litigation Name' },
  { accessor: 'activeStatus', Header: 'Status' }
];

export const LitigationTypeMaster = () => {
  const dispatch = useDispatch();
  // const [perPage, setPerPage] = useState(15);
  const [pageSize, setPageSize] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [litigationTypeDetailsList, setLitigationTypeDetailsList] = useState([]);
  const [litigationTypeMasterList, setLitigationTypeMasterList] = useState([]);
  var responseLitigationCode = localStorage.getItem("EncryptedResponseLitigationTypeMasterCode")

  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  const getLitigationList = (page, size = pageSize, searchText) => {
    const data = {
      pageNumber: page,
      pageSize: size,
      searchText: searchText ? searchText : "",
      isDropDown: false,
    };
    setIsLoading(true);
    dispatch(
      getLitigationTypeMasterListAPI(
        data,
        response => {
          setIsLoading(false);
          setLitigationTypeMasterList(response.data.data.litigationList);
          setTotalCount(response.data.data.totalCount);
        },
        err => {
          setIsLoading(false)
          setLitigationTypeMasterList([]);
          console.log(err?.data.message);
        },
        headers
      )
    );
  };

  const getLitigationTypeDetailList = async (litigationCode, index) => {
    const data = {
      LitigationCode: litigationCode ? litigationCode : '',
    };
    setIsLoading(true);
    await dispatch(
      getLitigationTypeDetailListAPI(
        data,
         res => {
          if (res && res.length > 0) {
            dispatch(litigationTypeDetailAction(res));
          } else {
            dispatch(litigationTypeDetailAction([]));
          }
        },
        err => {
          console.log('something went wrong');
          dispatch(litigationTypeDetailAction([]));
        },
        headers
      )
    );
  };

  const litigationTypesMasterReducer = useSelector((state) => state.rootReducer.litigationTypesMasterReducer)
  var litigationTypeMasterData = litigationTypesMasterReducer.litigationTypeMaster;

  const litigationTypesDetailReducer = useSelector((state) => state.rootReducer.litigationTypesDetailReducer)
  const litigationTypesDetailData = litigationTypesDetailReducer.litigationTypeDetail;

  const formChangedReducer = useSelector((state) => state.rootReducer.formChangedReducer)
  var formChangedData = formChangedReducer.formChanged;

  let isFormChanged = Object.values(formChangedData).some(
    value => value === true
  );
  const statusUpdated = useSelector(
    state => state.rootReducer.litigationTypesMasterReducer.statusUpdated
  );
  // const litigationTypeMasterErrorReducer = useSelector((state) => state.rootReducer.litigationTypeMasterErrorReducer)
  // const litigationTypeMasterErr = litigationTypeMasterErrorReducer.litigationTypeMasterError;

  const [formHasError, setFormError] = useState(false);
  const [activeTabName, setActiveTabName] = useState();

  useEffect(() => {
    $('[data-rr-ui-event-key*="Add Litigation Type Detail"]').attr('disabled', true);
  }, []);

  useEffect(() => {
    if (statusUpdated) {
      getLitigationList(1, pageSize)
    }
  }, [statusUpdated, dispatch]);

  useEffect(() => {
    localStorage.removeItem('EncryptedResponseLitigationTypeMasterCode');
    getLitigationList(1, pageSize)
  }, []);

  const clearLitigationTypeMasterReducers = () => {
    dispatch(litigationTypeErrorAction(undefined));
    dispatch(formChangedAction(undefined));
    dispatch(litigationTypeDetailAction([]));
    dispatch(litigationTypeDetailErrorAction(undefined));
    // dispatch(litigationTypeAction([]));
  };

  $('[data-rr-ui-event-key*="Litigation List"]')
    .off('click')
    .on('click', function () {
      let isDiscard = $('#btnDiscard').attr('isDiscard');
      if (isDiscard != 'true' && isFormChanged) {
        setModalShow(true);
        setTimeout(function () {
          $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
        }, 50);
      } else {
        $('#btnNew').show();
        $('#btnSave').hide();
        $('#btnCancel').hide();
        $('[data-rr-ui-event-key*="Add Litigation Type Detail"]').attr('disabled', true);
        $('[data-rr-ui-event-key*="Litigation List"]').attr('disabled', false);
        getLitigationList(1, pageSize)
        localStorage.removeItem('EncryptedResponseLitigationTypeMasterCode');
        $('#btnDiscard').attr('isDiscard', false);
        dispatch(litigationTypeAction(undefined));
        clearLitigationTypeMasterReducers();
      }
    });

  $('[data-rr-ui-event-key*="Add Litigation Type Detail"]')
    .off('click')
    .on('click', function () {
      setActiveTabName('Add Litigation Type Detail');
      $('#btnNew').hide();
      $('#btnSave').show();
      $('#btnCancel').show();
    });

  const newDetails = () => {
    $('[data-rr-ui-event-key*="Add Litigation Type Detail"]').attr('disabled', false);
    $('[data-rr-ui-event-key="Add Litigation Type Detail"]').trigger('click');
    $('#btnSave').attr('disabled', false);
    clearLitigationTypeMasterReducers();
  };

  const cancelClick = () => {
    $('#btnExit').attr('isExit', 'false');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      $('[data-rr-ui-event-key*="Litigation List"]').trigger('click');
    }
  };

  const exitModule = () => {
    $('#btnExit').attr('isExit', 'true');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      window.location.href = '/dashboard';
    }
  };

  const discardChanges = () => {
    $('#btnDiscard').attr('isDiscard', 'true');
    if ($('#btnExit').attr('isExit') == 'true') {
      window.location.href = '/dashboard';
    }
    else {
      $('[data-rr-ui-event-key*="List"]').trigger('click');
      setModalShow(false);
    }
  };

  const litigationTypeMasterValidation = () => {
    const litigationNameErr = {};
    const litigationTypesDetailNameErr = {};
    let isValid = true;

    if (!litigationTypeMasterData.litigationName) {
      litigationNameErr.nameEmpty = 'Enter litigation name';
      isValid = false;
      setFormError(true);
    }

    if (litigationTypesDetailData.length < 1) {
      litigationTypesDetailNameErr.stateEmpty = "At least one litigation type detail required";
      setTimeout(() => {
        toast.error(litigationTypesDetailNameErr.stateEmpty, {
          theme: 'colored'
        });
      }, 1000);
      isValid = false;
      setFormError(true);
    } else if (litigationTypesDetailData && litigationTypesDetailData.length > 0) {
      litigationTypesDetailData.forEach((row, index) => {
        if (!row.litigationTypeDetailName) {
          litigationTypesDetailNameErr.nameEmpty = "Litigation type detail name is required";
          setTimeout(() => {
            toast.error(litigationTypesDetailNameErr.nameEmpty, {
              theme: 'colored'
            });
          }, 1000);
          isValid = false;
          setFormError(true);
        }
      });
    }

    if (!isValid) {
      var errorObject = {
        litigationNameErr,
      };
      var errorLitigationTypeDetailObject = {
        litigationTypesDetailNameErr
      };
      dispatch(litigationTypeErrorAction(errorObject));
      dispatch(litigationTypeDetailErrorAction(errorLitigationTypeDetailObject))
    }

    return isValid;
  };

  const addLitigationTypeMasterDetails = async () => {
    if (litigationTypeMasterValidation()) {
      if (!formChangedData.litigationTypeMasterDetailAdd) {
        return;
    }
      const requestData = {
        litigationName: litigationTypeMasterData.litigationName,
        AddLitigationTypesDetail: litigationTypesDetailData,
        AddUser: localStorage.getItem('LoginUserName')
      };

      const keys = ['litigationName','AddUser'];
      for (const key of Object.keys(requestData).filter(key => keys.includes(key))) {
        requestData[key] = requestData[key] ? requestData[key].toUpperCase() : '';
      }
      const litigationTypesDetailKey = ['litigationTypeDetailName', 'activeStatus', 'addUser'];
      var index = 0;
      for (var obj in requestData.AddLitigationTypesDetail) {
        var litigationTypeDetailObj = requestData.AddLitigationTypesDetail[obj];

        for (const key of Object.keys(litigationTypeDetailObj).filter((key) => litigationTypesDetailKey.includes(key))) {
          litigationTypeDetailObj[key] = litigationTypeDetailObj[key] ? litigationTypeDetailObj[key].toUpperCase() : '';
        }
        requestData.AddLitigationTypesDetail[index] = litigationTypeDetailObj;
        index++;
      }
      setIsLoading(true);
      await dispatch(
        addLitigationTypeMasterAPI(
          requestData,
          response => {
            setIsLoading(false);
            toast.success(` ${response.data.message}`, {
              theme: 'colored',
              autoClose: 10000
            });

            dispatch(
              litigationTypeAction({
                ...litigationTypeMasterData,
                encryptedLitigationCode: response.data.data.encryptedLitigationCode,
                // litigationName: response.data.data.litigationName,
                litigationCode: response.data.data.litigationCode,
              })
            );
            updateCallback(true, response.data.data.encryptedLitigationCode);
            setModalShow(false);
            localStorage.setItem(
              'EncryptedResponseLitigationTypeMasterCode',
              response.data.data.encryptedLitigationCode
            );
          },
          err => {
            setIsLoading(false)
            toast.error(err?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
          },
          headers
        )
      );
    }
  };

  const updateCallback = (isAddLitigationType = false) => {
    setModalShow(false);
    dispatch(formChangedAction(undefined));
    getLitigationTypeDetailList(responseLitigationCode);
    if (!isAddLitigationType) {
      toast.success('Litigation detail updated successfully!', {
        theme: 'colored'
      });
    }

    $('#btnSave').attr('disabled', true);
    clearLitigationTypeMasterReducers();
    getLitigationList(1, pageSize);

    $('[data-rr-ui-event-key*="' + activeTabName + '"]').trigger('click');
  };

  const updateLitigationTypeMaster = async () => {
    if (litigationTypeMasterValidation()) {
      if (!formChangedData.litigationTypeMasterUpdate &&
        !(formChangedData.litigationTypeMasterDetailAdd ||
          formChangedData.LitigationTypeMasterDetailUpdate)) {
        return;
      }
      
      const updateLitigationTypeMasterData = {
        encryptedLitigationCode: localStorage.getItem(
          'EncryptedResponseLitigationTypeMasterCode'
        ),
        subLitigationCode: litigationTypeMasterData.subLitigationCode,
        litigationName: litigationTypeMasterData.litigationName,
        activeStatus: litigationTypeMasterData.activeStatus,
        ModifyUser: localStorage.getItem('LoginUserName')
      };

      const keys = ['litigationName', 'ModifyUser'];
      for (const key of Object.keys(updateLitigationTypeMasterData).filter(
        key => keys.includes(key)
      )) {
        updateLitigationTypeMasterData[key] = updateLitigationTypeMasterData[
          key
        ]
          ? updateLitigationTypeMasterData[key].toUpperCase()
          : '';
      }

      var hasError = false;

      if (formChangedData.litigationTypeMasterUpdate) {
        setIsLoading(true);
        await dispatch(
          updateLitigationTypeMasterAPI(
            updateLitigationTypeMasterData,
            response => {
              if (response.data.status == 200) {
                // dispatch(
                //   litigationTypeAction({
                //     ...litigationTypeMasterData,
                //     encryptedLitigationCode: litigationTypeMasterData.encryptedLitigationCode,
                //      litigationName: litigationTypeMasterData.litigationName,
                //   })
                // );
                setIsLoading(false);
                setModalShow(false);
              } else {
                hasError = true;
              }
            },
            err => {
              setIsLoading(false);
              toast.error(err?.data.message, {
                theme: 'colored',
                autoClose: 10000
              });
              hasError = true;
            },
            headers
          )
        );
      }

      var litigationTypeMasterDetailIndex = 1;

      if (
        !hasError &&
        (formChangedData.litigationTypeMasterDetailAdd ||
          formChangedData.LitigationTypeMasterDetailUpdate)
      ) {
        for (let i = 0; i < litigationTypesDetailData.length; i++) {
          const litigationTypeMasterDetailData = litigationTypesDetailData[i];

          const keys = ['litigationTypeDetailName', 'ModifyUser'];
          for (const key of Object.keys(litigationTypeMasterDetailData).filter(
            key => keys.includes(key)
          )) {
            litigationTypeMasterDetailData[key] =
              litigationTypeMasterDetailData[key]
                ? litigationTypeMasterDetailData[key].toUpperCase()
                : '';
          }

          if (
            !hasError &&
            formChangedData.LitigationTypeMasterDetailUpdate &&
            litigationTypeMasterDetailData.subLitigationCode
          ) {
            const updateLitigationTypeMasterDetailData = {
              encryptedLitigationCode: localStorage.getItem(
                'EncryptedResponseLitigationTypeMasterCode'
              ),
              encryptedLitigationTypeDetailCode: litigationTypeMasterDetailData.subLitigationCode,
              litigationTypeDetail: litigationTypeMasterDetailData.litigationTypeDetailName,
              activeStatus: litigationTypeMasterDetailData.activeStatus,
              ModifyUser: localStorage.getItem('LoginUserName')
            };
            setIsLoading(true);
            await dispatch(
              updateLitigationTypeMasterDetailAPI(
                updateLitigationTypeMasterDetailData,
                response => {
                  if (response.data.status == 200) {
                    setIsLoading(false);
                    setModalShow(false);
                  } else {
                    hasError = true;
                  }
                },
                err => {
                  setIsLoading(false);
                  toast.error(err?.data.message, {
                    theme: 'colored',
                    autoClose: 10000
                  });
                  hasError = true;
                },
                headers
              )
            );
            if (hasError) break;
          } else if (
            !hasError &&
            formChangedData.litigationTypeMasterDetailAdd &&
            !litigationTypeMasterDetailData.subLitigationCode
          ) {
            const data = {
              encryptedLitigationCode: localStorage.getItem(
                'EncryptedResponseLitigationTypeMasterCode'
              ),
              litigationTypeDetailName: litigationTypeMasterDetailData.litigationTypeDetailName,
              activeStatus: litigationTypeMasterDetailData.activeStatus,
              addUser: localStorage.getItem('LoginUserName')
            };
            setIsLoading(true);
            await dispatch(
              addLitigationTypeMasterDetailAPI(
                data,
                response => {
                  if (response.data.status == 200) {
                    setIsLoading(false);
                    setModalShow(false);
                    getLitigationTypeDetailList(responseLitigationCode);
                  } else {
                    hasError = true;
                  }
                },
                // res => {
                //   setIsLoading(false);
                //   setModalShow(false);
                //   getLitigationTypeDetailList(responseLitigationCode);
                // },
                err => {
                  setIsLoading(false);
                  toast.error(err?.data.message, {
                    theme: 'colored',
                    autoClose: 10000
                  });
                  hasError = true;
                },
                headers
              )
            );
            if (hasError) break;
          }
          litigationTypeMasterDetailIndex++;
        }
      }
      if (!hasError) {
        clearLitigationTypeMasterReducers();
        updateCallback();
      }
    }
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
  className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to save changes?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={
                !litigationTypeMasterData.encryptedLitigationCode
                  ? addLitigationTypeMasterDetails
                  : updateLitigationTypeMaster
              }
            >
              Save
            </Button>
            <Button
              variant="danger"
              id="btnDiscard"
              onClick={() => discardChanges()}
            >
              Discard
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <TabPage1
        listData={litigationTypeMasterList}
        listColumnArray={listColumnArray}
        tabArray={tabArray}
        module="LitigationTypeMaster"
        saveDetails={
          litigationTypeMasterData.encryptedLitigationCode
            ? updateLitigationTypeMaster
            : addLitigationTypeMasterDetails
        }
        newDetails={newDetails}
        cancelClick={cancelClick}
        exitModule={exitModule}
        pageSize={pageSize}
        setPageSize={value => setPageSize(value)}
        searchText={searchText}
        setSearchTextValue={value => setSearchText(value)}
        fetchList={getLitigationList}
        listCount={totalCount}
      />
    </>
  );
};

export default LitigationTypeMaster;